export default __webpack_public_path__ + "static/generic-e84891eeb0dcf3459c00e0982f43df92.png";